import { render, staticRenderFns } from "./AddMenuCategory.vue?vue&type=template&id=380c3870&"
import script from "./AddMenuCategory.vue?vue&type=script&lang=js&"
export * from "./AddMenuCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddMenuCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports